import React, { useState } from 'react';
import FormGroup from "react-bootstrap/FormGroup";
import Input from "reactstrap/es/Input";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox";


function TournamentStep2(props) {

	const [checked, setChecked] = useState(new Array());

	const handleToggle = value => () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		setChecked(newChecked);
		props.onChange(newChecked);
	};

	const handleKeydown = (e) => {
		console.log(e.target.value);
	};

	return (
		<div>
			<FormGroup>
				<Input type="text" name="searchFish" id="searchFish" placeholder="Search" onKeyUp={handleKeydown}/>
			</FormGroup>
			<List dense >
				{props.fish ?
					props.fish.map(value => {
					const labelId = `checkbox-list-secondary-label-${value.id}`;
					return (
						<ListItem key={value.id} button>
							<ListItemAvatar>
								<Avatar
									alt={`Avatar n°${value.id}`}
									src={`${value.img}`}
								/>
							</ListItemAvatar>
							<ListItemText id={labelId} primary={`${value.name} - ${value.name_en}`} />
							<ListItemSecondaryAction>
								<Checkbox
									edge="end"
									onChange={handleToggle(value)}
									checked={checked.indexOf(value) !== -1}
									inputProps={{ 'aria-labelledby': labelId }}
								/>
							</ListItemSecondaryAction>
						</ListItem>
					);
				})
					: ''
				}
			</List>
		</div>
	);
}

export default TournamentStep2;
